/**
 * @file index.js
 * @author Miguel Zabala
 * @description Initialize LoginStaffCallback View.
 */

// Dependencies
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Redux Actions
import * as actions from '@nephro/redux/stores/app/actions';
import * as authActions from '@nephro/redux/stores/auth/actions';
import * as userActions from '@nephro/redux/stores/user/actions';
import * as patientActions from '@nephro/redux/stores/patient/actions';

// View
import View from './loginStaffCallbackView';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToProps = (state) => ({
  loading: state.getIn(['AppState', 'loading']),
  user: state.getIn(['AppState', 'user']),
  response: state.getIn(['AppState', 'response']).toJS()
});

/**
 * Map dispatch to props
 * @param dispatch - Run the  process to execute in the action
 * @returns { object }
 */
export const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
  authActions: bindActionCreators(authActions, dispatch),
  userActions: bindActionCreators(userActions, dispatch),
  patientActions: bindActionCreators(patientActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
